// extracted by mini-css-extract-plugin
module.exports = {"blue":"TextButtonColors_blue__1UbGf","red":"TextButtonColors_red__1Fr4E"};